import { render } from "./cta.vue?vue&type=template&id=4115f672&scoped=true"
import script from "./cta.vue?vue&type=script&lang=js"
export * from "./cta.vue?vue&type=script&lang=js"

import "./cta.vue?vue&type=style&index=0&id=4115f672&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4115f672"

export default script